define('components/legacy-helpers',[
    'jquery'
], function($) {

    // Legacy helper functions. Can completely be removed when overviews/_searchjs.html and the dependency in sbisector/sbisector.html are removed

    $.extend(companyInfo.decorators, {
        'sbi-title': function() {
            if (!companyInfo.sectors || !companyInfo.sectors.length) {
                return;
            }
            companyInfo.sbi = companyInfo.helpers.getSbiObj(sbicode);
            this.innerHTML = companyInfo.sbi ? companyInfo.sbi[companyInfo.lang] : '';
        }
    });
    
    companyInfo.helpers = {

        getSbiObj: function(code) {
            var i, len, sector;
            for (i = 0, len = companyInfo.sectors.length; i < len; i++) {
                sector = companyInfo.sectors[i];
                if (sector.id == code || sector.c == code) {
                    return sector;
                }
            }
            if (code.substring(code.length - 1) == '0') {
                return companyInfo.helpers.getSbiObj(code.substring(0, code.length - 1));
            }
            return false;
        },

        explodeSbi: function(sbicode) {
            if (sbicode.length == 1) {
                var sbiSection = sbicode.substring(0, 1).toUpperCase(), i, len, results = [], sector;
                for (i = 0, len = companyInfo.sectors.length; i < len; i++) {
                    sector = companyInfo.sectors[i];
                    if (sector.l == 2 && sbiSection == sector.c.substring(0, 1)) {
                        results.push(sector.id);
                    } else if (results.length) {
                        break;
                    }
                }
                return results.join(';');
            } else {
                return sbicode.substring(1);
            }
        },

        makeNumber: function (text) {
            var sep = ".";
            var num = parseInt(text, 10);
            if ( !isNaN(num) ){
                var sign = (num == (num = Math.abs(num)));
                num = num.toString();
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++){
                    num = num.substring(0,num.length-(4*i+3))+ sep +num.substring(num.length-(4*i+3));
                }
                return ((sign)?'':'-') + num;
            }
            return text;
        },

        getSector: function(nr) {
            var sector = null;
            var main_nr = nr.substring(0, 2);
            var sub_nr = nr.substring(2, 4);
            var branche_nr = nr.substring(4, 6);
            if (main_nr) {
                sector = companyInfo.sectors['m' + main_nr];
            }
            if (sub_nr) {
                sector = (sector ? sector.s['s' + sub_nr] : null);
            }
            if (branche_nr) {
                    sector = sector = (sector ? sector.b['b' + branche_nr] : null);
            }
            return sector;
        },

        getSBIDescription: function(s, lang) {
            var sector;
            var text = '';
            var o;
            if (s !== null && s !== '') {
                if (s.substring(0,1) != 's') {
                    o = companyInfo.helpers.getSector(s);
                } else {
                    var sbi = s.substring(1, s.length);
                    var mainnr = (sbi.substring(0,2).length>0) ? sbi.substring(0,2) : null;
                    if (mainnr) {
                        var section = companyInfo.helpers.getSection(sbi.substring(0,2));
                        if (section) {
                            o = companyInfo.helpers.getSBI(section + sbi);
                        }
                    }
                }
                if (o) {
                    text = o[lang];
                }
            }
            return text;
        }

    };

    return companyInfo.helpers;

});
